export default __webpack_public_path__ + "static/media/advt.67d126b1.jpg";